import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PagerService } from '../../../../../common/services/Pagination.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ModalCancelStampComponent } from '../../popup/modalCancelStamp.component';
import { ModalLockListStampComponent } from '../../popup/modalLockListStamp/modalLockListStamp.component';
import { ModalDeleteStampComponent } from '../../popup/confirmDeleteStamp/modalDeleteStamp.component'
import { BatchService } from '../batch.service';
import { ExportService } from '../../../../../common/services/Export.service';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/primeng';
import { ModalActivePrintBatchComponent } from '../../popup/modalActivePrintBatch.component';
import { IOption } from 'ng-select';
import { environment } from '../../../../../../environments/environment';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ModalListBatchChildComponent } from './modalListBatchChild.component';
import { Subscription } from 'rxjs/Subscription';
import { ImageService } from '../../../../imageService';

declare function baseTracking(appId);

declare function enterScreenView(screenName: any, contentType: any, referrer: any);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare function alertMsg(alertType: any, alertMessage: any);

declare function searchEvent(keywords: any, params: any, order: any, sort: any)

declare var $: any;

@Component({
  selector: 'app-list',
  templateUrl: './list-detail.template.html',
  styleUrls: ['./batch-list.css'],
})
export class ListComponent implements OnInit, OnDestroy {
  @ViewChild('cd') cd: any;
  isCreate: Boolean = false;
  isCrating: Boolean = false;
  isSaleout: Boolean = false;
  isDistribution: Boolean = false;
  isActive: Boolean = false;
  isUpdate: Boolean = false;
  page_title = 'Danh sách lô tem';

  // tslint:disable-next-line:comment-format
  //status batch
  batch_not_pay = 0;
  batch_paid = 1;
  batch_activated = 2;
  is_printing = 1;
  // tslint:disable-next-line:comment-format
  //status order_type
  stampDN = 0;
  stampIS = 1;

  /*config theo server cho dễ xử lý*/
  code_chonggia = 1;
  code_baohanh = 2;
  code_tranhang = 3;
  code_dinhdanh = 5;
  params: any = {};
  Infinity = Infinity;
  list_status_filter: Array<IOption> = [
    // { value: this.batch_not_pay.toString(), label: 'Chưa Thanh Toán' },
    { value: this.batch_paid.toString(), label: 'Chưa kích hoạt' },
    { value: this.batch_activated.toString(), label: 'Đã kích hoạt' },
  ];
  list_order_type_filter: Array<IOption> = [
    { value: this.stampDN.toString(), label: 'Tem doanh nghiệp' },
    { value: this.stampIS.toString(), label: 'Tem in sẵn' },
  ];

  is_downloading_batch = false;
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';

  public FormFilterBatchStamp: FormGroup;
  public current_filter: any = {};
  public message: { content: string; alert_type: string } = null;
  public list_items: any = [];
  has_list = true;
  public item_detail: any = {};
  public item_active = 0;
  loadingDetail = false;

  logs_distribution: any = [];
  listEcommerce: any = [];

  public pager: any;
  public currentPage = 1;
  public page_size = 10;
  public totalRow = 0;

  bsModalRef: BsModalRef;
  // isActiveBatch: Boolean = false;

  bsModalImport: BsModalRef;
  bsModalImportCrating: BsModalRef;
  bsModalDownload: BsModalRef;
  bsConfirmModalDownload: BsModalRef
  // isExcel: boolean = true;
  // isImporting: Boolean = false;
  fileExcel: any;
  columns: any = {};
  password: any;
  excel: any = {};
  // allBatchs: any = [];
  numberStamp: any = null;

  subcribe: Subscription = null;
  subcribeChangeSetting: Subscription = null;
  subcribeListEcommerce: Subscription = null;
  errMsgAlertBoxStamp: '';

  public qrm = '';
  numberID = 0;
  // listBatchs: Array<IOption> = [];

  isDownImport = false;
  /* Tuanba:12/4/2022: Mekongas*/
  source = Number(JSON.parse(localStorage.getItem('User')).source)
  batchId: any

  // tslint:disable-next-line:member-ordering

  //
  // getListEcommerce(id) {
  //   this.subcribeListEcommerce = this.batchService
  //     .listEcommerce(id)
  //     .subscribe((res: any) => {
  //       this.listEcommerce = res.data.items
  //     })
  // }
  pageIndexLogDistribution = 1;
  pageSizeLogDistribution = 10;
  total_data_logDistribution = 0;

  /**
   * Tuanba: 5/5/2023: Tải về lô tem theo trạng thái
   **/

  downloadBatchStatus: 1

  user_email: any

  constructor(
    private batchService: BatchService,
    private exportService: ExportService,
    private fb: FormBuilder,
    private pagerService: PagerService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private confirmationService: ConfirmationService,
    private activatedRoute: ActivatedRoute,
    private imageService: ImageService,
    private router: Router,
    private translate: TranslateService
  ) {


    this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
    this.translate.get('DANH_SACH_LO_TEM').subscribe((res: string) => {
      this.page_title = res;
      this.updateTranslations();
    });
    this.subcribe = this.modalService.onHide.subscribe(() => {
      // this.viewDetail(this.item_active);
      this.excel = {};
      this.fileExcel = null;
      this.numberStamp = null;
      // if (this.isImporting == false) {
      //     this.viewDetail(this.item_active)
      // }
      // this.isImporting = false;
    });

  }

  changeSetting(productLinkId) {
    const dataElement = `input[name="ecommerceCheckbox${productLinkId}"]:checked`
    const body = { status: $(dataElement).serialize() ? 1 : 0 }
    this.subcribeChangeSetting = this.batchService
      .changeSetting(this.list_items[this.item_active].id, productLinkId, body)
      .subscribe((res: any) => {
        // console.log(res)
        if (res.code === 1) {
          this.toastr.success(this.translate.instant('THAY_DOI_TRANG_THAI_THANH_CONG'), this.translate.instant('THANH_CONG_CHAM'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      })
  }


  updateTranslations() {
    this.translate.get([
      'DANH_SACH_LO_TEM',
      'CHUA_KICH_HOAT',
      'DA_KICH_HOAT',
      'TEM_DOANH_NGHIEP',
      'TEM_IN_SAN',
      'TRANG_THAI',
      'LOAI_TEM',
      'CHON_DICH_VU'
    ]).subscribe(translations => {
      this.page_title = translations['DANH_SACH_LO_TEM'];
      this.list_status_filter = [
        { value: this.batch_paid.toString(), label: translations['CHUA_KICH_HOAT'] },
        { value: this.batch_activated.toString(), label: translations['DA_KICH_HOAT'] },
      ];
      this.list_order_type_filter = [
        { value: this.stampDN.toString(), label: translations['TEM_DOANH_NGHIEP'] },
        { value: this.stampIS.toString(), label: translations['TEM_IN_SAN'] },
      ];
      setTimeout(() => {
        if ($('#status').length) {
          $('#status').select2({
            placeholder: translations['TRANG_THAI'],
            allowClear: false,
            minimumResultsForSearch: -1,
          });
        }
        if ($('#ordertype').length) {
          $('#ordertype').select2({
            placeholder: translations['LOAI_TEM'],
            allowClear: false,
            minimumResultsForSearch: -1,
          });
        }
        if ($('.selectpicker').length) {
          $('.selectpicker').selectpicker({
            style: 'btn-select',
            iconBase: 'icon',
            tickIcon: 'wb-check',
            title: translations['CHON_DICH_VU']
          });
          $('.selectpicker').selectpicker('refresh');
        }
      }, 50);
    });
  }

  ngOnDestroy() {
    if (this.subcribe) {
      this.subcribe.unsubscribe();
    }
    if (this.subcribeChangeSetting) {
      this.subcribeChangeSetting.unsubscribe();
    }
    if (this.subcribeListEcommerce) {
      this.subcribeListEcommerce.unsubscribe();
    }
  }

  createFormFilter() {
    this.FormFilterBatchStamp = this.fb.group({
      service: [[]],
      // batch_id: [null],
      status: [this.params.status],
      ordertype: [this.params.ordertype],
      created_time_ranger: [null],
      name: [null],
    });
  }

  public loadData(request: any = null) {
    // console.log(this.current_filter);
    this.isCreate = false;
    this.isCrating = false;
    this.isDistribution = false;
    this.isActive = false;

    const data_get: any = request ? request : this.current_filter;
    if (this.currentPage < 0) {
      this.currentPage = 1;
    }

    // let data_get2 = {};
    // for (let key in data_get) {
    //   data_get2[key]= data_get[key];
    // }
    // data_get = data_get2;

    data_get.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    data_get.limit = this.page_size;

    this.batchService
      .getBatchesList(data_get)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          // this.setPage(this.currentPage);
          const list: any = [];
          for (const _data of res.data.batches) {
            const arr_services: any = this.convertServiceToText(_data.services);
            const obj = {
              id: _data.id,
              name: _data.name,
              quantity: _data.quantity,
              active_left: _data.active_left,
              has_child: _data.active_left != null,
              total_activated:
                _data.active_left == null
                  ? 0
                  : _data.quantity - _data.active_left,
              arr_services: arr_services,
              status: _data.status,
              is_printing: _data.is_printing,
              order_type: _data.order_type,
              image: this.imageService.readSrcImage(_data.image, 'thumb_large'),
              created_time: moment(_data.created_time).format('DD/MM/yyyy'),
            };
            list.push(obj);
          }
          this.list_items = list;
          this.has_list = list.length > 0;
          this.item_active = 0;
          // Chỉ gọi viewDetail nếu danh sách có phần tử
          if (this.list_items.length > 0) {
            this.viewDetail(0);
          } else {
            this.item_detail = null;
            this.has_list = false;
          }
        } else {
          console.log('getBatchesList:error', res);
        }
      })
      .catch((err: any) => {
        console.log('getBatchesList:catch', err);
      });
  }

  setPage(page: number) {
    console.log('check tracking')
    clickTracking('qcheck_batch_manage', 'batch_paging', 'qcheck_batch_manage', '')
    if (page < 1) {
      this.currentPage = 1;
      return;
    }
    this.pager = this.pagerService.getPager(
      this.totalRow,
      this.currentPage,
      this.page_size
    );
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.loadData();
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    } else {
      this.setPage(1); //toPage = 1;
    }
  }

  public viewDetail(i) {
    this.pageIndexLogDistribution = 1;
    console.log(1, i)
    this.is_downloading_batch = false;
    this.item_active = i;
    this.loadingDetail = true;
    if (this.isCreate == true) {
      this.toastr.warning(this.translate.instant('THAO_TAC_THEM_MOI_LO_TEM_DA_BI_HUY'), this.translate.instant('THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    if (this.isCrating == true) {
      this.toastr.warning(this.translate.instant('THAO_TAC_DONG_THUNG_DA_BI_HUY'), this.translate.instant('THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    if (this.isSaleout == true) {
      this.toastr.warning(this.translate.instant('THAO_TAC_CAU_HINH_SALE_OUT_DA_BI_HUY'), this.translate.instant('THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    if (this.isUpdate == true) {
      this.toastr.warning(this.translate.instant('THAO_TAC_SUA_LO_TEM_DA_BI_HUY'), this.translate.instant('THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    if (this.isDistribution == true) {
      this.toastr.warning(this.translate.instant('THAO_TAC_PHAN_PHOI_DA_BI_HUY'), this.translate.instant('THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    if (this.isActive == true) {
      this.toastr.warning(this.translate.instant('THAO_TAC_KICH_HOAT_DA_BI_HUY'), this.translate.instant('THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    this.isUpdate = false;
    this.isCreate = false;
    this.isCrating = false;
    this.isDistribution = false;
    this.isActive = false;
    $('.page-layout-detail').animate(
      { scrollTop: 0 },
      0,
      'swing',
      function () {
      }
    );
    this.batchId = this.list_items[i].id


    // get detail batch
    this.batchService
      .getBatchDetail(this.list_items[i].id)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.qrm = environment.domainQrcode + res.data.qrm_start;
          //get log phan phoi
          // if (res.data.active_left == null) {
          console.log(213);
          this.getLogDistribution(this.list_items[i].id);
          // }
          // this.getListEcommerce(res.data.id);

          // xu ly detail
          this.loadingDetail = false;
          let is_paid = false;
          if (
            res.data.status == this.batch_paid ||
            res.data.status == this.batch_activated
          ) {
            is_paid = true;
          }

          const arr_services = this.convertServiceToText(res.data.services);
          this.item_detail = {
            name: res.data.name,
            point: res.data.point || 0,
            id: res.data.id,
            created_time: res.data.created_time,
            created_time_f: moment(res.data.created_time).format('DD/MM/YYYY'),
            produce_time: res.data.produce_time,
            produce_time_f: moment(res.data.produce_time).format('DD/MM/YYYY'),
            guarantee_days: res.data.guarantee_days,
            guarantee_days_max: res.data.guarantee_days_max,
            guarantee_days_update: res.data.guarantee_days_update,
            guarantee_days_max_update: res.data.guarantee_days_max_update,
            quantity: res.data.quantity,
            arr_services: arr_services,
            buy_services: res.data.buy_services,
            batch_order_code: res.data.batch_order_code,
            batch_product_number: res.data.batch_product_number,
            batch_sku: res.data.batch_sku,
            batch_vendor_code: res.data.batch_vendor_code,
            id_start: res.data.id_start,
            id_end: res.data.id_end,
            prefix_id: res.data.prefix_id,
            prefix: res.data.prefix,
            has_log: res.data.has_log,
            serial:
              this.formatSerial(res.data.id_start, res.data.prefix) +
              ' – ' +
              this.formatSerial(res.data.id_end, res.data.prefix),
            serial_start: this.formatSerial(res.data.id_start, res.data.prefix),
            status: res.data.status,
            is_paid: is_paid,
            is_printing: res.data.is_printing,
            counter: res.data.counter,
            counter_warning: res.data.counter_warning,
            counter_scan: res.data.counter_scan,
            counter_scan_warning: res.data.counter_scan_warning,
            only_icheck: res.data.only_icheck,
            product_id: res.data.product_id,
            product_name: res.data.product_name,
            product_image: this.imageService.readSrcImage(
              res.data.product_image,
              'thumb_medium'
            ),
            is_chonggia: this.checkService(
              res.data.services,
              this.code_chonggia
            ),
            is_baohanh: this.checkService(res.data.services, this.code_baohanh),
            is_tranhang: this.checkService(
              res.data.services,
              this.code_tranhang
            ),
            is_dinhdanh: this.checkService(
              res.data.services,
              this.code_dinhdanh
            ),
            is_manufacturer: res.data.is_manufacturer,
            show_vendor: res.data.show_vendor,
            show_distributor: res.data.show_distributor,
            messages: res.data.messages,
            has_child: res.data.active_left != null,
            active_left: res.data.active_left,
            //isImportChild: (res.data.last_imported && res.data.quantity_imported) ? true : false,
            isImportChild: false,
            status_import: res.data.status_import,
            user_created: res.data.user_created,
            user_created_name: res.data.user_created_name,
            suggest_apps: res.data.suggest_apps,
            active_buy_online: res.data.active_buy_online,
            is_special: res.data.is_special,
            location_type: res.data.location_type,
            type_guarantee_day: res.data.type_guarantee_day,
            type_guarantee_day_max: res.data.type_guarantee_day_max,
            option_need_profile: res.data.option_need_profile,
            time_alert: res.data.time_alert,
            time_alert_type: res.data.time_alert_type,
            order_type: res.data.order_type,
            restore_setting: res.data.restore_setting,
            code: res.data.code != null ? res.data.code : '',
            init_status: res.data.init_status,
            init_tx_hash: res.data.init_tx_hash,
            init_timestamp: res.data.init_timestamp ? moment(res.data.init_timestamp).format('DD/MM/YYYY HH:mm:ss') : '',
            batch_config: res.data.batch_config
          };
          console.log('status: ' + this.item_detail.status)
          console.log('this.is_chonggia' + this.item_detail.is_chonggia)
          console.log('this.is_baohanh' + this.item_detail.is_baohanh)
          console.log('this.is_dinhdanh' + this.item_detail.is_dinhdanh)
          console.log('this.is_tranhang' + this.item_detail.is_tranhang)

          // fix list when close popup
          this.list_items[i].created_time = this.item_detail.created_time_f;

          //update list when close popup
          this.list_items[i].name = this.item_detail.name;
          this.list_items[i].quantity = this.item_detail.quantity;
          this.list_items[i].arr_services = this.item_detail.arr_services;
          this.list_items[i].status = this.item_detail.status;
          this.list_items[i].image = this.item_detail.product_image;
          this.list_items[i].total_activated =
            this.item_detail.active_left == null
              ? 0
              : this.item_detail.quantity - this.item_detail.active_left;
          this.list_items[i].has_child = this.item_detail.active_left != null;
        } else {
          console.log('getBatchDetail:error', res);
        }
      })
      .catch((err) => {
        console.log('getBatchDetail:catch:', err);
      });
  }

  viewDetailTracking() {
    enterScreenView('qcheck_batch_detail', 'others', '');
    clickTracking('qcheck_batch_manage', 'batch_detail', '', this.batchId);
  }

  checkService(services_list: string, code_service: any) {
    return services_list.indexOf(code_service.toString()) != -1;
  }

  confirm_paid() {
    this.confirmationService.confirm({
      message:
        `
      <div class="text-center">
        Xác nhận thanh toán lô tem:<br> "<strong>` +
        this.item_detail.name +
        `</strong>"
      </div>
      `,
      header: 'Xác nhận thanh toán',
      // icon: 'wb-payment',
      accept: () => {
        this.batchService.confirmPaid(this.item_detail.id).subscribe(
          (res: any) => {
            if (res.error === false) {
              this.list_items[this.item_active].status = this.batch_paid;
              this.item_detail.status = this.batch_paid;
              this.item_detail.is_paid = true;
              const mess = 'Lô tem của bạn đã được xác nhận thanh toán';
              this.toastr.success(mess, this.translate.instant('THANH_CONG_CHAM'), {
                timeOut: 4000,
                positionClass: 'toast-top-right',
              });
            } else {
              const mess = res.message
                ? res.message
                : 'Xác nhận thanh toán chưa thành công. Vui lòng thử lại sau!';
              this.toastr.warning(mess, this.translate.instant('THONG_BAO_CHAM'), {
                timeOut: 4000,
                positionClass: 'toast-top-right',
              });
            }
          },
          (err: any) => {
            const mess = err.message
              ? err.message
              : 'Xác nhận thanh toán chưa thành công. Vui lòng thử lại sau!';
            this.toastr.error(mess, this.translate.instant('THONG_BAO_CHAM'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
          }
        );
      },
    });
  }

  showPopupDistribution() {
    this.isDistribution = true;
    this.isActive = false;
    this.isUpdate = false;
    this.isCreate = false;
    this.isCrating = false;

    // this.isList = false;

    // const initialState = {
    //   batch_detail: this.item_detail,
    // };
    // this.bsModalRef = this.modalService.show(ModalDistributionComponent, {
    //   initialState,
    // });
    // this.bsModalRef.content.closeBtnName = "Bỏ qua";
  }

  /** Tuanba: 3-9-2025: Thêm modal xóa lô tem với tem chưa kích hoạt **/

  showPopupDeleteStamp() {
    const initialState = {
      batch_detail: this.item_detail,
    };
    this.bsModalRef = this.modalService.show(ModalDeleteStampComponent, {
      initialState,
    });
    this.bsModalRef.content.btnClose = 'Hủy bỏ';
    this.bsModalRef.content.btnConfirm = 'Xác nhận';
    this.bsModalRef.content.cModalTitle = 'Xác nhận xóa';
    console.log('vao day truowc ko')
    this.bsModalRef.content.refreshListStamp.subscribe(async (event: string) => {
      if (event) {
        console.log('xong moi vao day')
        this.current_filter = {};
        this.currentPage = 1;
        await this.loadData();
      }
      console.log('event', event);
    });
  }

  showPopupCancelStamp() {
    clickTracking('qcheck_batch_detail', 'stamp_lock', 'stamp_lock_alert', '');
    const initialState = {
      batch_detail: this.item_detail,
    };
    this.bsModalRef = this.modalService.show(ModalCancelStampComponent, {
      initialState,
    });
    this.bsModalRef.content.closeBtnName = this.translate.instant('BO_QUA');
  }

  showPopupLockListStamp() {
    const initialState = {
      batch_detail: this.item_detail,
    };
    this.bsModalRef = this.modalService.show(ModalLockListStampComponent, {
      initialState,
    });
    this.bsModalRef.content.closeBtnName = this.translate.instant('BO_QUA');
  }

  showPopupActivePrint() {
    // this.isActiveBatch = false;
    const initialState = {
      batch_detail: this.item_detail,
    };
    this.bsModalRef = this.modalService.show(ModalActivePrintBatchComponent, {
      initialState,
    });
    this.bsModalRef.content.closeBtnName = 'Quay lại';
  }

  showPopupLogsActiveBatchChild() {
    // this.isActiveBatch = false;
    clickTracking('qcheck_batch_detail', 'qcheck_batch_active_his', '', this.batchId)
    const initialState = {
      batch_detail: this.item_detail,
    };
    this.bsModalRef = this.modalService.show(ModalListBatchChildComponent, {
      initialState,
      class: 'modal-list-batch-child',
    });
    this.bsModalRef.content.closeBtnName = 'Quay lại';
  }

  isPrinting() {
    clickTracking('qcheck_batch_detail', 'stamp_print', '', '');
    // this.confirmationService.confirm({
    //   message: `
    //   <div class="text-center">
    //     Xác nhận in lô tem:<br> "<strong>` + this.item_detail.name + `</strong>"
    //   </div>
    //   `,
    //   header: 'In tem',
    //   // icon: 'wb-payment',
    //   accept: () => {
    //
    //   }
    // });
    // Khỏi cần confirm bên trên
    this.batchService
      .setBatchPrinting(this.item_detail.id, { is_printing: 1 })
      .subscribe(
        (res: any) => {
          if (res.error === false) {
            this.list_items[this.item_active].is_printing = 1;
            this.item_detail.is_printing = 1;
            const mess = 'Lô tem của bạn đã chuyển sang trạng thái đang in';
            this.toastr.success(mess, this.translate.instant('THANH_CONG_CHAM'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
          } else {
            const mess = res.message
              ? res.message
              : 'Thao tác chưa thành công. Vui lòng thử lại sau!';
            this.toastr.warning(mess, this.translate.instant('THONG_BAO_CHAM'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
          }
        },
        (err: any) => {
          const mess = err.message
            ? err.message
            : 'Thao tác chưa  thành công. Vui lòng thử lại sau!';
          this.toastr.error(mess, this.translate.instant('THONG_BAO_CHAM'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      );
  }

  cancelPrinting() {
    this.batchService
      .setBatchPrinting(this.item_detail.id, { is_printing: 0 })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.list_items[this.item_active].is_printing = 0;
          this.item_detail.is_printing = 0;
          const mess = 'Yều cầu dừng in tem thành công';
          this.toastr.success(mess, this.translate.instant('THANH_CONG_CHAM'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        } else {
          const mess = res.message
            ? res.message
            : 'Thao tác chưa thành công. Vui lòng thử lại sau!';
          this.toastr.warning(mess, this.translate.instant('THONG_BAO_CHAM'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
          console.log('setBatchPrinting:error', res);
        }
      })
      .catch((err: any) => {
        const mess = 'Thao tác chưa thành công. Vui lòng thử lại sau!';
        this.toastr.warning(mess, this.translate.instant('THONG_BAO_CHAM'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        console.log('setBatchPrinting:error', err);
      });
  }

  showDownloadBatch(templateDownload) {
    clickTracking('qcheck_batch_detail', 'batch_download', 'form_batch_download', '')
    this.bsModalDownload = this.modalService.show(templateDownload);
    // this.getPasswordEmailDownloadBatch()
  }

  getPasswordEmailDownloadBatch() {
    console.log('batch ID', this.batchId)
    this.batchService.getPasswordDownloadBatch(this.batchId).toPromise().then((res) => {
      if (res.status == 200 && res.data) {
        console.log('res')
        this.user_email = res.data.receiverEmail
      }
    })
  }

  downloadBatchWithPassword() {
    if (Object.keys(this.columns).length <= 0) {
      this.toastr.warning(this.translate.instant('PHAI_CHON_IT_NHAT_MOT_COT'), this.translate.instant('THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
      return;
    } else {
      if (!this.password) {
        this.toastr.warning(this.translate.instant('PASSWORD_KHONG_DUOC_DE_TRONG'), this.translate.instant('THONG_BAO_CHAM'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        })
        return;
      } else {
        const body = {
          passwordDownload: this.password,
          typeStampExport: []
        }
        if (this.columns.serial) {
          body.typeStampExport.push('serial');
        }
        if (this.columns.qrm) {
          body.typeStampExport.push('qrm');
        }
        if (this.columns.qri) {
          body.typeStampExport.push('qri');
        }
        if (this.columns.sms) {
          body.typeStampExport.push('sms');
        }
        this.batchService
          .downloadBatchWithPassword(this.batchId, body)
          .toPromise()
          .then((res: any) => {
            if (res.status == 200 && res.data) {
              this.bsModalDownload.hide();
              setTimeout(() => {
                this.confirmTemplateDownload.show();
              }, 500)
            } else {
              this.toastr.warning(res.message, this.translate.instant('THONG_BAO_CHAM'), {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
          })
          .catch((err: any) => {
            this.toastr.warning(err.message, this.translate.instant('THONG_BAO_CHAM'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          });
      }
    }
  }

  hideConfirmTemplateDownload() {
    this.confirmTemplateDownload.hide();
  }

  downloadBatch() {
    if (Object.keys(this.columns).length <= 0) {
      this.toastr.warning(this.translate.instant('PHAI_CHON_IT_NHAT_MOT_COT'), this.translate.instant('THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      const typeTrackingPayload = []
      for (const [key, value] of (<any>Object).entries(this.columns)) {
        if (value === true) {
          typeTrackingPayload.push(key);
        }
      }
      clickTracking('form_batch_download', 'download_submit', '', typeTrackingPayload.toString());
      const currentBatch = this.item_detail;
      const request: any = {};
      if (this.isDownImport) {
        request.start = currentBatch.id_start;
        request.end = currentBatch.id_end;
        request.prefix_id = currentBatch.prefix_id; // dm, cai nay nhớ là prefix_id nhé, đéo phải batch_id như ở link download bên dưới đâu nhé. LOL.@chuongnv
        request.prefix = currentBatch.prefix;
        request.fields = '&fields=';
        if (this.columns.serial) {
          request.fields += 'serial';
        }
        if (this.columns.qrm) {
          if (request.fields.length <= 0) {
            request.fields += 'qrm';
          } else {
            request.fields += ',qrm';
          }
        }
        if (this.columns.qri) {
          if (request.fields.length <= 0) {
            request.fields += 'qri';
          } else {
            request.fields += ',qri';
          }
        }
        if (this.columns.sms) {
          if (request.fields.length <= 0) {
            request.fields += 'sms';
          } else {
            request.fields += ',sms';
          }
        }
        // let ext = 'xlsx';
        // let filename = '#'+this.item_detail.id+'_'+this.item_detail.name+'.'+ext;
        let query =
          '?start=' + request.start + '&end=' + request.end + request.fields;
        if (localStorage.getItem('Access-Token')) {
          query += '&Access_Token=' + localStorage.getItem('Access-Token');
        }
        console.log('query', query);
        const url = environment.linkDownloadBatchVer2 + query;
        // let url =
        //   environment.api_evs +
        //   '/stamps/batch/' +
        //   currentBatch.id +
        //   '/download' +
        //   query;
        // console.log('url', url)

        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        // a.target = '_blank'
        a.click();
        // window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
        this.columns = {};
      } else {
        this.batchService
          .getTokenDownloadBatch(this.item_detail.prefix_id.toString())
          .toPromise()
          .then((res: any) => {
            console.log('tuandayy', res)
            if (!res.error && res.data.token_access) {
              request.start = currentBatch.id_start;
              request.end = currentBatch.id_end;
              request.prefix_id = currentBatch.prefix_id; // dm, cai nay nhớ là prefix_id nhé, đéo phải batch_id như ở link download bên dưới đâu nhé. LOL
              request.prefix = currentBatch.prefix;
              request.domain = environment.domainQrcode;
              request.fields = '';
              if (this.columns.serial) {
                request.fields += 'serial';
              }
              if (this.columns.qrm) {
                if (request.fields.length <= 0) {
                  request.fields += 'qrm';
                } else {
                  request.fields += ',qrm';
                }
              }
              if (this.columns.qri) {
                if (request.fields.length <= 0) {
                  request.fields += 'qri';
                } else {
                  request.fields += ',qri';
                }
              }
              if (this.columns.sms) {
                if (request.fields.length <= 0) {
                  request.fields += 'sms';
                } else {
                  request.fields += ',sms';
                }
              }
              // let ext = 'xlsx';
              // let filename = '#'+this.item_detail.id+'_'+this.item_detail.name+'.'+ext;
              const query =
                '?start=' +
                request.start +
                '&end=' +
                request.end +
                '&batch_id=' +
                request.prefix_id +
                '&prefix=' +
                request.prefix +
                '&fields=' +
                request.fields +
                '&domain=' +
                request.domain +
                '&access_token=' +
                res.data.token_access;
              const url = environment.linkDownloadBatchVer2 + query;
              const a = document.createElement('a');
              document.body.appendChild(a);
              a.setAttribute('style', 'display: none');
              a.href = url;
              const fileName = 'sample1111';
              a.download = fileName
              // a.target = '_blank'
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove(); // remove the element
              this.columns = {};
            } else {
              console.log('getTokenDownloadBatch:error', res);
              this.toastr.warning(
                'Tải về không thành công, vui lòng thử lại sau !',
                this.translate.instant('THONG_BAO_CHAM'),
                {
                  timeOut: 4000,
                  positionClass: 'toast-top-right',
                }
              );
            }
          })
          .catch((err: any) => {
            console.log('getTokenDownloadBatch:catch', err);
            this.toastr.warning(
              'Tải về không thành công, vui lòng thử lại sau !',
              this.translate.instant('THONG_BAO_CHAM'),
              {
                timeOut: 4000,
                positionClass: 'toast-top-right',
              }
            );
          });
      }
    }
  }

  submitFilterBatch(data
    :
    any = {}
  ) {
    console.log('tuanba', 123123123)
    this.currentPage = 1;
    const data_filter: any = {};
    const param_traking: any = {};
    let name_tracking: any = {};
    const keywords: any = {};


    if (data.service && data.service.length > 0) {
      data_filter.service = data.service.toString();
      name_tracking = this.convertServiceToText(data.service).map(a => a.name).toString();
      param_traking.service = name_tracking;
      keywords.service = name_tracking
    }

    if (data.name) {
      data_filter.name = data.name;
      param_traking.name = data.name;
      keywords.name = data.name;
    }
    if ($('#status').val()) {
      data_filter.status = $('#status').val();
      param_traking.status = $('#status').val();
      keywords.status = $('#status').val();
    }
    if ($('#ordertype').val()) {
      data_filter.order_type = $('#ordertype').val();
      param_traking.order_type = $('#ordertype').val();
      keywords.order_type = $('#ordertype').val();
    }
    if (data.created_time_ranger) {
      data_filter.from = moment(data.created_time_ranger[0]).format(
        'YYYY-MM-DD'
      );
      data_filter.to = moment(data.created_time_ranger[1]).format('YYYY-MM-DD');

      param_traking.from = moment(data.created_time_ranger[0]).format(
        'YYYY-MM-DD'
      );
      param_traking.to = moment(data.created_time_ranger[1]).format('YYYY-MM-DD');

      keywords.from = moment(data.created_time_ranger[0]).format(
        'YYYY-MM-DD'
      );
      keywords.to = moment(data.created_time_ranger[1]).format('YYYY-MM-DD');

    }
    this.current_filter = data_filter;
    searchEvent(JSON.stringify(keywords), JSON.stringify(param_traking), '', '');
    visibleContent('qcheck_batch_manage', 'qcheck_search_batch', '')
    this.loadData();
  }

  ResetFormSearch() {
    // $('#sl_service').val('').trigger('change');
    // $('#sl_status').val('').trigger('change');
    $('#filter_service').selectpicker('val', '');
    $('#status').val('').trigger('change');
    $('#ordertype').val('').trigger('change');
    this.FormFilterBatchStamp.reset();
  }

  convertServiceToText(service: string) {
    const arr_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_chonggia.toString()) !== -1) {
      arr_services.push({
        code: this.code_chonggia,
        name: this.translate.instant('CHONG_GIA'),
      });
    }
    if (service.indexOf(this.code_baohanh.toString()) !== -1) {
      arr_services.push({
        code: this.code_baohanh,
        name: this.translate.instant('BAO_HANH'),
      });
    }
    if (service.indexOf(this.code_tranhang.toString()) !== -1) {
      arr_services.push({
        code: this.code_tranhang,
        name: this.translate.instant('TRAN_HANG'),
      });
    }
    if (service.indexOf(this.code_dinhdanh.toString()) !== -1) {
      arr_services.push({
        code: this.code_dinhdanh,
        name: this.translate.instant('DINH_DANH'),
      });
    }
    return arr_services;
  }

  formatSerial(id, prefix) {
    let serial_f = '';
    id = id.toString();
    if (id && prefix) {
      const pad = '000000';
      const serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  setSort(sort
    :
    string
  ) {
    if (sort) {
      this.current_filter.sort_by = sort;
      this.loadData();
    }
  }

  showCreate() {
    this.isCreate = true;
    this.isUpdate = false;
    this.isCrating = false;
    this.isDistribution = false;
    this.isActive = false;
    clickTracking('qcheck_batch_manage', 'batch_add', 'qcheck_batch_add', '');
    enterScreenView('qcheck_batch_add', 'batch_add', '');
  }

  showCrating() {
    this.isCrating = true;
    this.isCreate = false;
    this.isUpdate = false;
    this.isDistribution = false;
    this.isActive = false;
    clickTracking('qcheck_batch_manage', 'qcheck_stamp_package', 'qcheck_stamp_package', '');
    enterScreenView('qcheck_stamp_package', 'stamp_package', '')
  }

  showCratingFile() {
    this.isCrating = true;
    this.isCreate = false;
    this.isUpdate = false;
    this.isDistribution = false;
    this.isActive = false;
  }

  showSaleout() {
    this.isSaleout = true;
    this.isCreate = false;
    this.isUpdate = false;
    this.isDistribution = false;
    this.isActive = false;
  }

  ngOnInit() {
    this.createFormFilter();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      console.log('params', params);
      if (params) {
        this.params.name = params.batchName;
        console.log('this.....', this.params.name);
        this.FormFilterBatchStamp.controls.name.setValue(params.batchName)
        this.loadData(this.params)
      }
    });
    $('.stampBoxStampAlert').css('display', 'none');
    baseTracking(environment.appIdTracking);
    enterScreenView('qcheck_batch_manage', 'others', '');
    $('.selectpicker').selectpicker({
      style: 'btn-select',
      iconBase: 'icon',
      tickIcon: 'wb-check',
    });

    $('#status').select2({
      placeholder: this.translate.instant('TRANG_THAI'),
      allowClear: false,
      minimumResultsForSearch: -1,
    });
    $('#ordertype').select2({
      placeholder: this.translate.instant('LOAI_TEM'),
      allowClear: false,
      minimumResultsForSearch: -1,
    });
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.params.status = params.status;
      this.params.ordertype = params.ordertype;
      this.loadData(this.params);
    });
  }

  hideCreate(event) {
    this.isCreate = false;
    this.isCrating = false;
    this.isUpdate = false;
    this.isDistribution = false;
    this.isActive = false;
    console.log('event', event);
    if (event.alert == 1) {
      $('.stampBoxStampAlert').css('display', 'block');
      this.errMsgAlertBoxStamp = event.errMsg;
      setTimeout(() => {
        $('.stampBoxStampAlert').css('display', 'none');
      }, 4000)
    }
    if (event.isBack == false) {
      // delete this.arr_sort['created_time'];
      // this.setSort('created_time', 'desc');
      this.current_filter = {};
      this.currentPage = 1;
      this.loadData();
    }
    if (event.updated == true) {
      this.viewDetail(this.item_active);
    }
  }

  hideCrating(event) {
    console.log(event)
    this.isCreate = false;
    this.isCrating = false;
    this.isUpdate = false;
    if (event.isBack == false) {
      // delete this.arr_sort['created_time'];
      // this.setSort('created_time', 'desc');
      this.current_filter = {};
      this.currentPage = 1;
      this.loadData();
    }
    if (event.updated == true) {
      this.viewDetail(this.item_active);
    }
  }

  showUpdate() {
    this.isUpdate = true;
    this.isCreate = false;
    this.isCrating = false;
    this.isDistribution = false;
    this.isActive = false;
    clickTracking('qcheck_batch_detail', 'batch_update', 'qcheck_batch_update', '');
    enterScreenView('qcheck_batch_update', 'others', '');
  }

  showActive() {
    this.isUpdate = false;
    this.isCreate = false;
    this.isCrating = false;
    this.isDistribution = false;
    this.isActive = true;
    clickTracking('qcheck_batch_detail', 'stamp_active', this.batchId, '');
  }

  getLogDistribution(batch_id
    :
    number
  ) {
    console.log('batch_id', batch_id)
    const query: any = {};
    query.page = this.pageIndexLogDistribution;
    query.page_size = this.pageSizeLogDistribution;
    if (batch_id) {
      this.batchService
        .getDistributionOfBatch(batch_id, query)
        .toPromise()
        .then((res: any) => {
          if (res.data.items && res.data.items.length > 0) {
            const list: any = [];

            for (const _data of res.data.items) {
              const obj = {
                serial:
                  this.formatSerial(_data.id_start, _data.prefix) +
                  ' – ' +
                  this.formatSerial(_data.id_end, _data.prefix),
                address: _data.address,
                district: _data.districts,
                city: _data.provinces,
                created_time: moment(_data.created_time).format('DD-MM-YYYY'),
                note: _data.note,
              };
              list.push(obj);
            }
            this.total_data_logDistribution = res.data.totalElement

            console.log('list', list)
            this.logs_distribution = list;
            console.log('this.logs_distribution', this.logs_distribution);

          } else {
            this.logs_distribution = [];

            console.log('getDistribution:error', res);
          }
        })
        .catch((err: any) => {
          this.logs_distribution = [];

          console.log('getDistribution:catch', err);
        });
    } else {
      this.logs_distribution = [];
    }
  }

  // Phân trang log phân phối
  prePageLogDistribution() {
    console.log('tuanba', this.batchId);
    if (this.pageIndexLogDistribution > 1) {
      this.pageIndexLogDistribution = this.pageIndexLogDistribution - 1;
      this.getLogDistribution(this.batchId);
    }
  }

  lastPageLogDistribution() {
    console.log('tuanba', this.batchId);
    if (
      this.pageIndexLogDistribution * this.pageSizeLogDistribution <
      this.total_data_logDistribution
    ) {
      this.pageIndexLogDistribution = this.pageIndexLogDistribution + 1;
      this.getLogDistribution(this.batchId);
    }
  }

  inputPageLogDistributionChange(event) {
    console.log('tuanba', this.batchId);
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexLogDistribution) {
      this.pageIndexLogDistribution = page;
      this.getLogDistribution(this.batchId);
    }
  }

  openImport(template) {
    clickTracking('qcheck_batch_detail', 'map_code', 'form_map_code', '');
    visibleContent('qcheck_batch_detail', 'form_map_code', '');
    this.bsModalImport = this.modalService.show(template, {
      class: 'modal-lg',
    });
  }

  hideMapping() {
    this.bsModalImport.hide();
  }

  /**
   * Đóng thùng bằng file
   */
  showImportCrating(templateImportCrating) {
    this.bsModalImportCrating = this.modalService.show(templateImportCrating, {
      class: 'modal-lg',
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    });
  }

  hideMappingCrating() {
    this.bsModalImportCrating.hide();
  }

  navigateTo(page: any) {
    this.router.navigate([page]);
  }

  messageCrating(event) {
    $('.stampBoxStampAlert').css('display', 'block');
    this.errMsgAlertBoxStamp = event;
    setTimeout(() => {
      $('.stampBoxStampAlert').css('display', 'none');
    }, 4000)
    console.log('event', event)
  }

  loadDataChild($event: any) {
    this.loadData();
  }

  hideDistribution(event) {
    this.isDistribution = event.isDistribution
    this.loadData();
    this.toastr.warning(this.translate.instant('DA_DONG_GIAO_DIEN_PHAN_PHOI'), this.translate.instant('THONG_BAO'), {
      timeOut: 4000,
      positionClass: 'toast-top-right'
    })
  }

  /** Tuanba:5/5/2023: Download lô tem theo trạng thái **/
  changeTabDownloadBatch(param: any) {
    this.downloadBatchStatus = param
  }

  selectTabDownload(param: any) {
    if (param == 'status') {
      this.downloadBatchStatus = 1
    }
  }

  // tslint:disable-next-line:member-ordering
  @ViewChild('confirmTemplateDownload') confirmTemplateDownload: ModalDirective;

  downloadBatchAction() {
    const body = {
      exportTypeEnum: 'STAMP_RANGE_IN_BATCH',
      fields: {
        batchId: this.item_detail.id,
        status: this.downloadBatchStatus
      }
    }
    this.exportService.exportReport(body).subscribe((res) => {
      console.log('resss', res)
      if (res.code === 1) {
        this.toastr.success(this.translate.instant('VUI_LONG_TAI_FILE_O_THONG_BAO'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      } else {
        this.toastr.warning(this.translate.instant('XAY_RA_LOI'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error, this.translate.instant('CANH_BAO_CHAM'),
        {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        }
      );
    })
  }

  acceptDownloadBatch() {
    $('.stampBoxStampAlert').css('display', 'none');
    // Thực hiện logic download batch nếu cần
  }

  closeAlertDownload() {
    $('.stampBoxStampAlert').css('display', 'none');
  }
}




// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/list/list.component.ts